module.exports = __webpack_public_path__ + "static/media/mockup-wealthy.56b50597.png";